<template>
  <div class="item-bg">
    <div class="item-img" >
      <img :src="itemObj.thumb_path" alt="img" :style="{border:  selected.includes(itemObj) ? '2px #1890ff solid'  : '' }" />
    </div>
    <div class="item-title">{{itemObj.scene_title}}</div>
  </div>
</template>

<script>
export default {
  props: {
    itemObj: {
      type: Object,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  create() {
    console.log(itemObj);
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.item-bg {
  width: 64px;
  margin-bottom: 10px;
  cursor: pointer;
  .item-img {
    width: 64px;
    height: 64px;
    border-radius: 4px;
    background: #f8f8f8;
    img {
      width: 64px;
      height: 64px;
      border-radius: 4px;
      object-fit: contain;
      border:1px solid transparent;
    }
  }
  .item-title {
    color: rgba(67, 67, 67, 1);
    font-size: 12px;
    line-height: 2;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.active {
  // border: 4px solid #1890ff;

  border: 3px #1890ff solid;
}
</style>